

export const VendorEndpoints = {
   filter : 'api/Vendor/Filter',
   insert : 'api/Vendor/Insert',
   
  };